import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";

interface FetchGradingRubricJsonParams {
  uuid: string;
  contextType?: string;
  contextUuid?: string;
}

export default {
  // note: there is another fetchGradingRubric in resource.json.api.ts
  fetchGradingRubric: (uuid) => {
    return httpClient.get(`/apis/grading-rubrics/get/${uuid}`);
  },
  createGradingRubric: (requestData) => {
    return httpClient.post(`/apis/grading-rubrics/create`, requestData, {
      headers: {
        "X-With-Richtext": true,
      },
    });
  },
  saveGradingRubric: (requestData) => {
    return httpClient.post(`/apis/grading-rubrics/save`, requestData, {
      headers: {
        "X-With-Richtext": true,
      },
    });
  },
  deleteGradingRubric: ({ uuid, type }) => {
    return httpClient.post(`/apis/grading-rubrics/delete/${type}/${uuid}`, {}, {});
  },
  fetchGradingRubricJson: (
    params: string | FetchGradingRubricJsonParams,
  ): Promise<ApiResponse<string>> => {
    const uuid = typeof params === "string" ? params : params.uuid;
    const queryParams = getQueryParams(params);
    return httpClient.get(`/apis/grading-rubrics/json/${uuid}`, { params: queryParams });
  },
  updateGradingRubricCriterionScore: (
    assignmentUuid: string,
    questionAttemptAnswerId: string,
    criteriaId: number,
    newScore: number,
    academicYear: number,
    noAutoFeedback: boolean,
  ): Promise<ApiResponse<object>> => {
    return httpClient.post(
      `/apis/grading-rubrics/criteria/score/update/${assignmentUuid}/${questionAttemptAnswerId}/${criteriaId}`,
      {
        newScore,
        academicYear,
        noAutoFeedback,
      },
    );
  },
};

const getQueryParams = (params: string | FetchGradingRubricJsonParams): URLSearchParams => {
  const queryParams = new URLSearchParams();
  if (typeof params === "string") {
    return queryParams;
  }
  if (params.contextType) {
    queryParams.append("contextType", params.contextType);
  }
  if (params.contextUuid) {
    queryParams.append("contextUuid", params.contextUuid);
  }
  return queryParams;
};
